/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1779
 */

"use strict"

require(/* 951 */"./951")("WeakSet", function (e) {
  return function () {
    return e(this, arguments.length ? arguments[0] : undefined)
  }
}, require(/* 1279 */"./1279"))
